import StepFlow from '@/febos/chile/dnt/components/wizard/flow/StepFlow';
import StepSignaturePosition from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePosition';
import {
  mapApprovalSteps
} from '@/febos/chile/approvals/wizardFlow/config/wizard/forms/approvalsCommons';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Enviar documento a flujo',
      component: StepFlow
    },
    {
      title: 'Ubicar firmas del documento',
      component: StepSignaturePosition,
      condition: (input) => input.setSignaturePosition,
      isLazy: true,
      draftOnBack: true
    }
  ],
  displayNextTitle: true,
  options: ['submit'],
  submitAction: 'sendToFlow',
  loadAllData: false,
  wizardMapper(rawData) {
    const principal = rawData.adjuntos.find((document) => document.tipo === 'principal');
    const haveSubjects = rawData.destinatarios.length;
    const origin = rawData.metadata.length && rawData.metadata
      .some((meta) => meta.nombre === 'origin' && meta.valor === 'repositorio');
    const matter = rawData.observaciones.length ? rawData.observaciones[0].observacion : '';
    console.log('PEPEP', rawData)
    return {
      fileUrl: principal.adjuntoUrl,
      fileIdFlow: principal.adjuntoId,
      fileName: principal.adjuntoNombre,
      fileNumber: rawData.numero,
      fileType: rawData.tipo,
      fileApproach: rawData.dnt.transportePuertoTipo,
      fileCategory: rawData.dnt.claseMercadoPublico,
      documentId: rawData.dnt.febosId,
      haveSubjects,
      origin,
      subjects: rawData.destinatarios,
      fileResumen: rawData.dnt.nombreDescriptivo,
      documentType: rawData.dnt.emisorSucursalPais || '',
      documentTypeValue: rawData.dnt.emisorCentroCostoNumero || '',
      documentTypeName: rawData.dnt.emisorCentroCostoNombre,
      document: rawData.dnt.emisorSucursalCiudad || '',
      documentValue: rawData.dnt.emisorSucursalCodigo || '',
      documentName: rawData.dnt.emisorSucursalDireccion || '',
      documentGroup: rawData.dnt.solicitanteGrupoId,
      matter
    };
  },
  documentMapper(input) {
    const data = {
      ejecucion: {
        privado: input.private ? 'Y' : 'N',
        descripcion: input.description,
        estampar: input.pdfStamp,
        nombre: input.name,
        numero: input.number,
        unidad: input.documentGroup,
        tipoObjetoCategoria: input.documentTypeName,
        tipoDocumentoId: input.documentValue,
        tipoDocumentoCodigo: input.documentValue,
        reversible: true,
        firmaPosicionada: input.setSignaturePosition ? 'Y' : 'N',
        plantilla: {
          aprobaciones: {
            nombre: input.name,
            descripcion: input.description,
            estampar: input.pdfStamp,
            foliacion: true,
            reversible: true,
            tipoejecucion: 'N',
            tipoObjeto: input.typeFlowId,
          },
          ...mapApprovalSteps(input)
        }
      },
      documentos: [
        {
          adjuntoId: input.fileIdFlow,
          adjuntoMime: input.fileMime,
          adjuntoNombre: input.fileName,
          adjuntoUrl: input.fileUrl,
          fecha: input.fileDate,
          objetoId: input.fileId,
          objetoNombre: input.fileName,
          tipoObjetoId: input.typeFlowId,
          tipoObjetoTexto: input.typeFlowText
        }
      ],
      gatillacionesPreDefinidas: [
        '451eeaef-4232-4963-84c8-ccf5366130df',
        'f13b799d-8640-4b42-a1e1-2e9044e038b5',
        '451eeaef-4232-4963-84c8-ccf5366130dr'
      ],
      referencias: [
        {
          linea: 1,
          tipoDocumento: input.typeFlowId,
          folio: input.number,
          fecha: input.fileDate,
          documentoId: input.fileId,
        }
      ]
    };

    if (input.isControlResolution) {
      data.meta = { oficinaAcciones: ['foliar'], indicador: ['contraloria'] };
    }
    if (input.isResolution) {
      data.meta = { oficinaAcciones: ['foliar', 'tramitar'] };
    }
    if ((input.isGore) && !['int', 'ext'].includes(input.fileCategory)) {
      data.meta = { oficinaAcciones: ['tramitar'] };
    }
    return data;
  }
});
